import { Route, Routes } from "react-router-dom";
import { IndexWrapper } from "./pages/index";
import { CheckoutWrapper } from "./pages/checkout/Checkout";
import { orderConfirmationWrapper } from "./pages/orderConfirmation/orderConfirmation";

function App() {
  	return (
		<>
			<Routes>
				<Route path="/" Component={IndexWrapper} />
				<Route path="/checkout" Component={CheckoutWrapper} />
				<Route path="/order/success/:orderId/accesskey/:accessKey" Component={orderConfirmationWrapper} />
			</Routes>
		</>
  	);
}

export default App;
